import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setAuthToken, getAuthToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, object=auth

  const checkAuth = useCallback(async () => {
    if (!getAuthToken()) {
      setUser((prev) => (prev && (prev._id || prev.id) ? prev : false));
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser((prev) => (prev && (prev._id || prev.id) ? prev : data));
    } catch {
      setAuthToken(null);
      setUser((prev) => (prev && (prev._id || prev.id) ? prev : false));
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.access_token) setAuthToken(data.access_token);
    setUser(data);
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    if (data?.access_token) setAuthToken(data.access_token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    } finally {
      setAuthToken(null);
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
